//=================================================
//    summary: DCP 購買提示視窗 -- Hook
//
//    remarks: 000 Tim 2021/11/05 Create
//================================================
import React, { useState, useEffect } from 'react'
import cssSubscriptionReminder from './SubscriptionReminder.module.scss'
import {LocalStorageLibs, GlobalLibs, NetworkLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false

let mobjCallParam = null
// #endregion Member Variables

// #region Enumeration
const ExpiredStatusEnum = {
    "NotExpired": -1,
    "Expired": 1,
    "WillExpire": 2
}

const ActionEnum = {
    "ProductUnitOnTap": 1,
    "LaterOnTap": 2
}
// #endregion Enumeration


const COMP_NAME = "SubscriptionReminder"

function SubscriptionReminder(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [doNotShow, setDoNotShow] = useState(false)
    // #endregion Init State

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
        }
    }, [])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 產品
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function ProductUnitOnTapHandler(ReminderIndex)
    {
        console.log(COMP_NAME + ".ProductUnitOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.open(window.gSession.Acc.SubscriptionReminder.Reminder[ReminderIndex].Link)

        if (window.gSession.Acc.Preferences.SRShow !== 1)
        {
            // 點選 購買頁面 就將 購買提醒 再度打開     Tim20.04.16
            // DCP 購買提醒 開關 1.On (default); 2.Off
            window.gSession.Acc.Preferences.SRShow = 1

            mobjCallParam = {
                "AccountID": window.gSession.Acc.ID,
                "CouterType": 2,               // 1. Trial 頁面 產品 點擊 統計 2: DCP Reminder 3: Subscription
                "ItemType": parseInt(window.gSession.Acc.SubscriptionReminder.Reminder[ReminderIndex].ItemType)                    // 各按鈕編號 
            }
            UpdateProductCounter()
        }
    } // end of ProductUnitOnTapHandler

    /*===========================================
    summary: 點選 稍後再處理
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function LaterOnTapHandler(StateDoNotShow)
    {
        console.log(COMP_NAME + ".LaterOnTapHandler: ", StateDoNotShow)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (StateDoNotShow)
        {
            console.log(COMP_NAME + ".LaterOnTapHandler 2 StateDoNotShow: ", StateDoNotShow)

            // DCP 購買提醒 開關 1.On: (default); 2.Off
            window.gSession.Acc.Preferences.SRShow = 2

            mobjCallParam = {
                "Action": ActionEnum.LaterOnTap,
                "AccPreferences": []
            }

            let objPref = {
                "Key": window.gAccPreferenceTypeEnum.SRShow,
                "Value": window.gSession.Acc.Preferences.SRShow
            }
            mobjCallParam.AccPreferences.push(objPref)

            SetAccountPreferences()
        }
        else
        {
            let objCallbackData = {
                "Action": "LaterOnTap"
            }
            props.CallbackRef(objCallbackData)
        }
    } // end of LaterOnTapHandler

    /*===========================================
    summary: 點選 不再顯示提示
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function DoNotShowOnTapHandler(StateDoNotShow)
    {
        console.log(COMP_NAME + ".DoNotShowOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        setDoNotShow(!StateDoNotShow)
    } // end of DoNotShowOnTapHandler
    // #endregion OnTapHandler

    // #region LoadingMask
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask
    // #endregion LoadingMask

    // #region Get ClassName
    /*===========================================
    summary: 取得 產品元件 Cls
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function GetProductUnitCls(ReminderData, ReminderIndex)
    {
        let objCls = cssSubscriptionReminder.divProductUnit

        if (parseInt(ReminderData.Default) === 1)
        {
            objCls = cssSubscriptionReminder.divProductUnitDefault
        }
        else
        {
            if (ReminderIndex === 0)
            {
                objCls = cssSubscriptionReminder.divProductUnitFirst
            }
            else
            {
                objCls = cssSubscriptionReminder.divProductUnit
            }
        }

        return objCls
    } // end of GetProductUnitCls

    /*===========================================
    summary: 取得 購買按鈕元件 Cls
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function GetOrderNowCls(ReminderDefault)
    {
        let objCls = cssSubscriptionReminder.btnOrderNow

        if (ReminderDefault === 1)
        {
            objCls = cssSubscriptionReminder.btnOrderNowDefault
        }

        return objCls
    } // end of GetOrderNowCls

    /*===========================================
    summary: 取得 是否下次不顯示按鈕 Cls
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function GetCheckCls(StateDoNotShow)
    {
        let objCls = cssSubscriptionReminder.btnUnCheck

        if (StateDoNotShow)
        {
            objCls = cssSubscriptionReminder.btnCheck
        }

        return objCls
    } // end of GetCheckCls
    // #endregion Get ClassName

    // #region Web Service After Process
    /*===========================================
    summary: 更新 按鈕 計次後 的 流程
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function UpdateProductCounterAfterProcess ()
    {   
        console.log(COMP_NAME + ".UpdateProductCounterAfterProcess")
        mobjCallParam = null

        mobjCallParam = {
            "Action": ActionEnum.ProductUnitOnTap,
            "AccPreferences": []
        }

        let objPref = {
            "Key": window.gAccPreferenceTypeEnum.SRShow,
            "Value": window.gSession.Acc.Preferences.SRShow
        }
        mobjCallParam.AccPreferences.push(objPref)

        SetAccountPreferences()
    } // end of UpdateProductCounterAfterProcess

    /*===========================================
    summary: 儲存 帳號設定後 的 流程
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function SetAccountPreferencesAfterProcess ()
    {   
        console.log(COMP_NAME + ".GetAccountDashboardAfterProcess")

        // save to local storage
        LocalStorageLibs.SetAccLSElement("Preferences", JSON.stringify(window.gSession.Acc.Preferences))

        if (
            (typeof(props.CallbackRef) !== 'undefined') &&
            (props.CallbackRef !== null)
            )
        {
            let objCallbackData = {
                "Action": ""
            }

            if (mobjCallParam.Action === ActionEnum.ProductUnitOnTap)
            {
                objCallbackData.Action = "ProductUnitOnTap"
            }
            else if (mobjCallParam.Action === ActionEnum.LaterOnTap)
            {
                objCallbackData.Action = "LaterOnTap"
            }
            props.CallbackRef(objCallbackData)
        }

        mobjCallParam = null
    } // end of SetAccountPreferencesAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 儲存 帳號設定
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function SetAccountPreferences ()
    {
        let objRetryFuncRef = SetAccountPreferences
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = SetAccountPreferencesCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_SetAccountPreferences)

            let objCallData = {
                "Func": "SetAccountPreferences",
                "PrefList": JSON.stringify(mobjCallParam.AccPreferences)
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of SetAccountPreferences

    /*===========================================
    summary: 儲存 帳號設定 Callback
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function SetAccountPreferencesCallback (Return, InstructionInfo)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_SetAccountPreferences_No
        let strErrorTitle = window.gAppUI.ERR_SetAccountPreferences_Title
        let strErrMsg = window.gAppUI.ERR_SetAccountPreferences_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("SetAccountPreferencesCallback: ErrNo: ", Return.ErrNo)
            console.log("SetAccountPreferencesCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("SetAccountPreferencesCallback Return.Data: ", Return.Data)

            SetAccountPreferencesAfterProcess()
        }
    } // end of SetAccountPreferencesCallback

    /*===========================================
    summary: 更新 按鈕 計次
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function UpdateProductCounter ()
    {
        let objRetryFuncRef = UpdateProductCounter
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = UpdateProductCounterCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_UpdateProductCounter)

            let objCallData = {
                "Func": "UpdateProductCounter",
                "AccountID": mobjCallParam.AccountID,
                "CouterType": mobjCallParam.CouterType, // 1. Trial 頁面 產品 點擊 統計 2: DCP Reminder 3: Subscription
                "ItemType": mobjCallParam.ItemType      // 各按鈕編號 
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of UpdateProductCounter

    /*===========================================
    summary: 更新 按鈕 計次 Callback
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function UpdateProductCounterCallback (Return, InstructionInfo)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_UpdateProductCounter_No
        let strErrorTitle = window.gAppUI.ERR_UpdateProductCounter_Title
        let strErrMsg = window.gAppUI.ERR_UpdateProductCounter_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("UpdateProductCounterCallback: ErrNo: ", Return.ErrNo)
            console.log("UpdateProductCounterCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("UpdateProductCounterCallback Return.Data: ", Return.Data)

            UpdateProductCounterAfterProcess()
        }
    } // end of UpdateProductCounterCallback
    // #endregion Web Service

    // #region Render元件
    /*===========================================
    summary: 不要再提示 文字2 顯示Component  
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function ComponentDoNotShowText2()
    {   
        return(
            <div className={cssSubscriptionReminder.divDoNotShowText2}>
                {window.gAppUI.LBL_SRDoNotShowMemo}
            </div>
        )
    } // end of ComponentDoNotShowText2

    /*===========================================
    summary: 不要再提示 SubContent 顯示Component  
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function ComponentDoNotShowSubContent({StateDoNotShow})
    {   
        return(
            <div className={cssSubscriptionReminder.divDoNotShowSubContent}>
                <div className={GetCheckCls(StateDoNotShow)}/>
                <div className={cssSubscriptionReminder.divDoNotShowText}>
                    {window.gAppUI.LBL_SRDoNotShow}
                </div>
            </div>
        )
    } // end of ComponentDoNotShowSubContent

    /*===========================================
    summary: 返回上一頁按鈕 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentLaterButton( {StateDoNotShow} )
    {   
        return(
            <div className={cssSubscriptionReminder.btnLater} onClick={() => LaterOnTapHandler(StateDoNotShow)}>
                {window.gAppUI.BTN_Later}
            </div>
        )
    } // end of ComponentLaterButton

    /*===========================================
    summary: Expiration Memo 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentExpirationMemo()
    {   
        return(
            <div className={cssSubscriptionReminder.divMemo}>
                {window.gAppUI.LBL_ExpirationMemo}
            </div>
        )
    } // end of ComponentExpirationMemo
    
    /*===========================================
    summary: Month Free 顯示Component  
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function ComponentOrderNow( {ReminderDefault} )
    {   
        return(
            <div className={GetOrderNowCls(ReminderDefault)}>
                {window.gAppUI.LBL_OrderNow}
            </div>
        )
    } // end of ComponentOrderNow

    /*===========================================
    summary: DueToday 顯示Component  
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function ComponentDueToday( {ReminderPrice} )
    {   
        let strText = "$ " + ReminderPrice + " " + window.gAppUI.LBL_DueToday

        return(
            <div className={cssSubscriptionReminder.divDueToday}>
                {strText}
            </div>
        )
    } // end of ComponentDueToday

    /*===========================================
    summary: Month Free 顯示Component  
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function ComponentMonthFree()
    {   
        return(
            <div className={cssSubscriptionReminder.divMonthFree}>
                {window.gAppUI.LBL_MonthFree}
            </div>
        )
    } // end of ComponentMonthFree

    /*===========================================
    summary: Price Per Month Desc 顯示Component  
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function ComponentPricePerMonthDesc()
    {   
        return(
            <div className={cssSubscriptionReminder.divPricePerMonthDesc}>
                {window.gAppUI.LBL_PerMonth}
            </div>
        )
    } // end of ComponentPricePerMonthDesc

    /*===========================================
    summary: 產品 Price Per Month Value  顯示Component  
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function ComponentPricePerMonthValue( {ReminderPricePerMonth} )
    {   
        return(
            <div className={cssSubscriptionReminder.divPricePerMonthMain}>
                <div className={cssSubscriptionReminder.divPricePerMonthSymbol}>
                    $
                </div>
                <div className={cssSubscriptionReminder.divPricePerMonthValue}>
                    {ReminderPricePerMonth}
                </div>
            </div>
        )
    } // end of ComponentPricePerMonthValue

    /*===========================================
    summary: 產品 Default Tip 顯示Component  
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function ComponentProgramText( {ReminderProgram} )
    {   
        return(
            <div className={cssSubscriptionReminder.divProgramText}>
                {ReminderProgram}
            </div>
        )
    } // end of ComponentProgramText

    /*===========================================
    summary: 產品 Default Tip 顯示Component  
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function ComponentProductDefaultTip( {ReminderDefault} )
    {   
        if (parseInt(ReminderDefault) === 1)
        {
            return(
                <div className={cssSubscriptionReminder.divProductDefaultTip}/>
            )
        }
        else
        {
            return ""
        }
    } // end of ComponentProductDefaultTip

    /*===========================================
    summary: 產品說明 Desc 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentProductDesc()
    {   
        return(
            <div className={cssSubscriptionReminder.divProductDesc}>
                {window.gAppUI.LBL_ProductDesc}
            </div>
        )
    } // end of ComponentProductDesc

    /*===========================================
    summary: Expiration 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentExpiration( {PropsExpiredStatus, PropsExpirationDate} )
    {   
        let strExpiration = "　"

        if (PropsExpiredStatus !== ExpiredStatusEnum.Expired)
        {
            strExpiration = window.gAppUI.LBL_ExpirationDate + " " + PropsExpirationDate
        }

        return(
            <div className={cssSubscriptionReminder.divExpiration}>
                {strExpiration}
            </div>
        )
    } // end of ComponentExpiration

    /*===========================================
    summary: 標題 顯示Component  
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function ComponentTitle( {PropsExpiredStatus, PropsIsTrial} )
    {   
        let strTitle = "　"

        if (PropsExpiredStatus === ExpiredStatusEnum.Expired)
        {
            if (!PropsIsTrial)
            {
                strTitle = window.gAppUI.LBL_SRTitle4Expired
            }
            else
            {
                strTitle = window.gAppUI.LBL_SRTitle4Expired4Trial
            }
        }
        else
        {
            if (!PropsIsTrial)
            {
                strTitle = window.gAppUI.LBL_SRTitle4WillExpire
            }
            else
            {
                strTitle = window.gAppUI.LBL_SRTitle4WillExpire4Trial
            }
        }

        return(
            <div className={cssSubscriptionReminder.divTitle}>
                {strTitle}
            </div>
        )
    } // end of ComponentTitle
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render DoNotShowContent 的顯示
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function RenderDoNotShowContentWrapper(StateDoNotShow)
    {
        console.log(COMP_NAME + ".RenderDoNotShowContentWrapper: ")
        return (
            <div className={cssSubscriptionReminder.divDoNotShowContent} onClick={() => DoNotShowOnTapHandler(StateDoNotShow)}>
                <ComponentDoNotShowSubContent StateDoNotShow={StateDoNotShow}/>
                <ComponentDoNotShowText2 />
            </div>
        )
    } // end of RenderDoNotShowContentWrapper

    /*===========================================
    summary: Render 產品 Unit 的顯示
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function RenderProductUnitWrapper(ReminderData)
    {
        console.log(COMP_NAME + ".RenderProductUnitWrapper: ")
        return (
            <>
                <ComponentProductDefaultTip ReminderDefault={parseInt(ReminderData.Default)}/>

                <ComponentProgramText ReminderProgram={ReminderData.Program}/>

                <ComponentPricePerMonthValue ReminderPricePerMonth={ReminderData.PricePerMonth}/>
                <ComponentPricePerMonthDesc />
                <ComponentMonthFree />

                <ComponentDueToday ReminderPrice={ReminderData.Price}/>
                
                <ComponentOrderNow ReminderDefault={parseInt(ReminderData.Default)}/>
            </>
        )
    } // end of RenderProductUnitWrapper

    /*===========================================
    summary: Render 產品Content 的顯示
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function RenderProductContentWrapper()
    {
        console.log(COMP_NAME + ".RenderProductContentWrapper: ")
        if (
            (typeof(window.gSession.Acc.SubscriptionReminder.Reminder) !== 'undefined') &&
            (window.gSession.Acc.SubscriptionReminder.Reminder !== null) &&
            (window.gSession.Acc.SubscriptionReminder.Reminder.length > 0)
            )
        {
            return (
                <div className={cssSubscriptionReminder.divProductContent}>
                    {window.gSession.Acc.SubscriptionReminder.Reminder.map((ReminderData, ReminderIndex) =>
                        <div key={ReminderIndex} className={GetProductUnitCls(ReminderData, ReminderIndex)} onClick={() => ProductUnitOnTapHandler(ReminderIndex)}>
                            {RenderProductUnitWrapper(ReminderData)}
                        </div>
                    )}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderProductContentWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        console.log(COMP_NAME + ".RenderContentWrapper: ")
        return (
            <div className={cssSubscriptionReminder.divContent}>
                <ComponentProductDesc />

                {RenderProductContentWrapper()}

                <ComponentExpirationMemo />

                <ComponentLaterButton StateDoNotShow={doNotShow}/>

                {RenderDoNotShowContentWrapper(doNotShow)}
            </div>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render Title Row 的顯示
    remarks: 000 Tim 2021/11/05 Create
    ===========================================*/
    function RenderTitleRowWrapper()
    {
        console.log(COMP_NAME + ".RenderTitleRowWrapper: ")
        return (
            <>
                <ComponentTitle PropsExpiredStatus={props.ExpiredStatus} PropsIsTrial={props.IsTrial} />
                <ComponentExpiration PropsExpiredStatus={props.ExpiredStatus} PropsExpirationDate={props.ExpirationDate} />
            </>
        )
    } // end of RenderTitleRowWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        console.log(COMP_NAME + ".RenderMainWrapper: ")
        return (
            <div className={cssSubscriptionReminder.divMask}>
                <div className={cssSubscriptionReminder.divMain}>
                    {RenderTitleRowWrapper()}
                    {RenderContentWrapper()}
                </div>
                
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default SubscriptionReminder